import React, { FC, useMemo } from "react"
import Link from "next/link"
import css from "@css/modules/Layout.module.scss"
import { MegaMenuProps, SellMegaMenu } from "@components/Layout/components/SellMegaMenu"
import { usePathname } from "next/navigation"
import { useMegMenu } from "@utils/hooks/useMegMenu"
import { MEGA_MENU_GROUP } from "@t/GeneralData"
import { FEATURE_FLAGS, useFeatureFlag } from "@contexts/FeatureFlagContext"

type MenuItem =
    | {
          title: string
          type?: undefined
          link: string
      }
    | {
          title: string
          type: MEGA_MENU_GROUP
          megaMenu: FC<MegaMenuProps>
      }

const menuList: MenuItem[] = [
    {
        title: "View listings",
        link: "/listings"
    },
    {
        title: "Hottest deals",
        link: "/hottest-deals"
    },
    {
        title: "Selling",
        type: MEGA_MENU_GROUP.SELL,
        megaMenu: SellMegaMenu
    },
    {
        title: "Resorts",
        link: "/resorts"
    },
    /*    {
        title: "FAQs",
        link: "/faq"
    },*/
    /*    {
        title: "Sell a contract",
        link: "/sell"
    },*/
    {
        title: "Blog",
        link: "/blog"
    },
    {
        title: "Points guide",
        link: "/points-guide"
    }
    /*
    {
        title: "How it works",
        link: "/how-it-works"
    },
    {
        title: "Take a demo",
        link: "/demo"
    }*/
]
type Props = { simpleMegaMenu?: boolean; onClose?: () => void }
export function Menu({ simpleMegaMenu, onClose }: Props) {
    const pathname = usePathname()
    const menuData = useMegMenu()
    const enableSellMenu = useFeatureFlag(FEATURE_FLAGS.enableSellMenu)

    const menuItems = useMemo(() => {
        let m = menuList
        if (!enableSellMenu) {
            m = m.filter((i) => i.type !== MEGA_MENU_GROUP.SELL)
        }
        return m.map((i, k) => {
            const isNotMega = "link" in i
            const megaProps = isNotMega ? undefined : menuData.find((m) => m.group === i.type)
            if (!isNotMega && megaProps) {
                const Mega = i.megaMenu
                return <Mega key={k} title={i.title} simpleMegaMenu={simpleMegaMenu} mega={megaProps} />
            } else if (isNotMega) {
                const active = i.link === pathname
                return (
                    <li key={k} className={css.headerMenuItem} data-active={active}>
                        <Link href={i.link} className={css.headerMenuItemLink} onClick={onClose}>
                            {i.title}
                        </Link>
                    </li>
                )
            }
        })
    }, [pathname, simpleMegaMenu, onClose, menuData, enableSellMenu])
    return <ul className={css.headerMenu}>{menuItems}</ul>
}
